module.exports = __webpack_public_path__ + "img/王春明.158c7538.jpg";